<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Companies",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('companies.singular')) }},
    resourceRoute: {default: 'companies'},
    modelVariable: {default: 'company'},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('companies.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('companies.plural')),
          href: "/companies",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/companies/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.name`)),
        value: this.model.name
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.address`)),
        item: this.model.address,
        value: {
          props: ['item'],
          template: `<span style="white-space: pre">{{ item || '-' }}</span>`
        }
      }, {
        key: this.lodash.upperFirst(this.$t('models.description')),
        item: this.model.description,
        value: {
          props: { item: {type: String, default: ''} },
          template: `<span v-html="item || '-'"></span>`
        }
      }]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/companies/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/companies/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
